export const Configuration = {
    path: '/alarms_configuration',
    name: 'alarms_configuration',
    component: () => import('@/views/Notification/Configuration.vue'),
}